<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Detalhes da compra" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading || loadingForm">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && !loadingForm && compra">
      <px-compra-detalhes-dados-basicos :compra="compra" @movimentar="onMovimentar"/>
      <px-compra-detalhes-tabs v-if="!showNotasFiscais"
                               class="mt-3"
                               card-class="mr-2" :compra="compra"/>
      <template v-if="showNotasFiscais">
        <v-row dense no-gutters class="d-flex flex-row mt-3 mb-3">
          <v-col cols="12" sm="6"
                 class="d-flex align-start justify-center">
            <px-compra-detalhes-tabs card-class="mr-2" :compra="compra"/>
          </v-col>
          <v-col cols="12" sm="6"
                 class="d-flex align-start justify-center">
            <px-compra-detalhes-notas-fiscais card-class="ml-2" :compra="compra"/>
          </v-col>
        </v-row>
      </template>
      <px-compra-detalhes-produtos :compra="compra"
                                   :campos-personalizados="camposPersonalizados"
                                   @update="onMovimentar"/>
      <px-gestao-entrega-produtos-compras v-if="isGestaoEntregaEnabled && showEntregas"
                                          :compra="compra"
                                          outlined/>
      <px-compra-detalhes-mensagens-personalizadas v-if="checkMessages"
                                                   :compra="compra"/>
      <px-compra-mensagem class="mt-3" :compra="compra" v-if="compra.fornecedor.hasUsers"/>
      <px-compra-detalhes-logs :id-compra="compra.id" v-if="hasIntegracaoAtiva"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EntidadeCamposPersonalizadosService
  from '@/modules/campos-personalizados/entidade-campos-personalizados-service';
import GestaoEntregaProdutosCompras
  from '@/modules/gestao-entregas/GestaoEntregaProdutosCompras.vue';
import CompraDetalhesNotasFiscais from '@/modules/compra/detalhes/CompraDetalhesNotasFiscais.vue';
import CompraDetalhesDadosBasicos from './CompraDetalhesDadosBasicos.vue';
import CompraDetalhesLogs from './logs-compra/CompraDetalhesLogs.vue';
import CompraDetalhesProdutos from './CompraDetalhesProdutos.vue';
import CompraDetalhesTabs from './CompraDetalhesTabs.vue';
import CompraMensagem from '../CompraMensagem.vue';
import CompraService from '../compra-service';
import CompraDetalhesMensagensPersonalizadas from './CompraDetalhesMensagensPersonalizadas.vue';

const isGestaoEntregaEnabled = process.env.VUE_APP_GESTAO_ENTREGA_V2_ENALED === 'true';

export default {
  name: 'px-compra-detalhes',
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    showEntregas: {
      type: Boolean,
      default: true,
    },
    compraIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isGestaoEntregaEnabled,
      compra: null,
      loading: false,
      loadingForm: false,
      compraId: null,
      backLink: this.$route.query.backLink,
      camposPersonalizados: null,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Compras', to: '/compras' },
        { text: 'Detalhes' },
      ],
    };
  },
  computed: {
    ...mapGetters('entidade', ['hasIntegracaoAtiva', 'idEntidade', 'erpCamposIntegracao']),
    ...mapGetters('user', ['hasRoleFiscal']),
    checkMessages() {
      return this.compra.mensagensPersonalizadas
        && this.compra.mensagensPersonalizadas.length;
    },
    showNotasFiscais() {
      return this.hasRoleFiscal;
    },
  },
  methods: {
    onClickBack() {
      if (this.backLink) {
        this.$router.push({ path: this.backLink });
        return;
      }
      this.$router.push({ name: 'main.compras' });
    },
    getCompra() {
      this.loading = true;
      CompraService.getCompraCompleto(this.compraId)
        .then((response) => {
          this.compra = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCamposPersonalizados() {
      EntidadeCamposPersonalizadosService.getCamposPersonalizadosCompraById(this.idEntidade)
        .then((campos) => {
          this.camposPersonalizados = campos;
        });
    },
    onMovimentar() {
      this.getCompra();
    },
  },
  created() {
    this.compraId = this.compraIdProp || this.$route.params.id;

    this.loadingForm = true;
    Promise.all([
      this.getCompra(),
      this.getCamposPersonalizados(),
    ])
      .finally(() => {
        this.loadingForm = false;
      });
  },
  components: {
    pxCompraDetalhesDadosBasicos: CompraDetalhesDadosBasicos,
    pxCompraDetalhesProdutos: CompraDetalhesProdutos,
    pxCompraDetalhesTabs: CompraDetalhesTabs,
    pxCompraMensagem: CompraMensagem,
    pxCompraDetalhesLogs: CompraDetalhesLogs,
    pxCompraDetalhesMensagensPersonalizadas: CompraDetalhesMensagensPersonalizadas,
    pxGestaoEntregaProdutosCompras: GestaoEntregaProdutosCompras,
    pxCompraDetalhesNotasFiscais: CompraDetalhesNotasFiscais,
  },
};
</script>
